<div class="dashboard">
  <div class="dashboard__header">
    <app-list-header title="Welcome back, {{ userName }}"
      subTitle="Here's what's happening with your documents and credits.">
    </app-list-header>
  </div>
  <div class="stats-row">
    <div class="stat-card">
      <div class="stat-card__content">
        <span class="stat-card__number">{{ documentsSignedCount }}</span>
        <span class="stat-card__label">Documents signed</span>
      </div>
      <div class="stat-card__icon stat-card__icon--green">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-card__content">
        <span class="stat-card__number">{{ creditsLeft }}</span>
        <span class="stat-card__label">Credits left</span>
      </div>
      <div class="stat-card__icon stat-card__icon--orange">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
        </svg>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-card__content">
        <span class="stat-card__number">{{ awaitingOthersCount }}</span>
        <span class="stat-card__label">Awaiting others</span>
      </div>
      <div class="stat-card__icon stat-card__icon--grey">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
      </div>
    </div>
  </div>
  <div class="dashboard__bottom">
    <div class="activity-card">
      <div class="activity-card__header">
        <span class="activity-card__title">RECENT ACTIVITY</span>
        <a class="activity-card__view-all" (click)="toggleAllActivity()" style="cursor:pointer">
          {{ showAllActivity ? 'Show less ‹' : 'View all ›' }}
        </a>
      </div>
      <div *ngIf="loadingTransactions" class="activity-list activity-list--empty common-message text-danger">
        <app-common-icon [loadingIcon]="loadingTransactions"></app-common-icon>
      </div>
      <div *ngIf="!loadingTransactions && transactions.length === 0"
        class="activity-list activity-list--empty common-message text-danger">
        <span>No recent activity</span>
      </div>
      <div *ngIf="!loadingTransactions && !transactions.length && transactionErrorMessage"
        class="activity-list activity-list--empty common-message text-danger">
        <span>{{ transactionErrorMessage }}</span>
      </div>
      <div class="activity-list" *ngIf="!loadingTransactions && transactions.length > 0">
        <div class="activity-item" *ngFor="let tx of showAllActivity ? transactions : transactions.slice(0, 4)">
          <div class="activity-item__icon-wrap" [ngClass]="{
                 'activity-item__icon-wrap--esign':    getActivityIcon(tx) === 'esign',
                 'activity-item__icon-wrap--send':     getActivityIcon(tx) === 'send',
                 'activity-item__icon-wrap--recharge': getActivityIcon(tx) === 'recharge'
               }">
            <ng-container *ngIf="getActivityIcon(tx) === 'esign'">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 20h9"></path>
                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
              </svg>
            </ng-container>
            <ng-container *ngIf="getActivityIcon(tx) === 'send'">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="22" y1="2" x2="11" y2="13"></line>
                <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
              </svg>
            </ng-container>
            <ng-container *ngIf="getActivityIcon(tx) === 'recharge'">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
              </svg>
            </ng-container>
          </div>
          <div class="activity-item__info">
            <span class="activity-item__title">{{ tx.description }}</span>
            <span class="activity-item__date">{{ tx.date | date: 'dd MMM yyyy, hh:mm a' }}</span>
          </div>
          <span class="activity-item__credits"
            [ngClass]="tx.type === 'Credit' ? 'activity-item__credits--positive' : 'activity-item__credits--negative'">
            {{ tx.formattedCredits }}
          </span>
        </div>
      </div>
      <div class="footer-page-ination" *ngIf="showAllActivity && transactionCount > 0">
        <app-paginator [totalCount]="transactionCount" (selectedPage)="onTransactionPageChange($event)"></app-paginator>
      </div>
    </div>
    <div class="right-col">
      <div class="wallet-card">
        <div class="wallet-card__header">
          <span class="wallet-card__label">WALLET</span>
          <div class="wallet-card__expand" [routerLink]="['/wallet']" style="cursor:pointer" title="Open wallet">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="15 3 21 3 21 9"></polyline>
              <polyline points="9 21 3 21 3 15"></polyline>
              <line x1="21" y1="3" x2="14" y2="10"></line>
              <line x1="3" y1="21" x2="10" y2="14"></line>
            </svg>
          </div>
        </div>
        <div class="wallet-card__balance">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="#ff8c5a">
            <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
          </svg>
          <span class="wallet-card__number">{{ walletCredits }}</span>
        </div>
        <p class="wallet-card__desc">{{ walletDescription }}</p>
        <button class="btn-recharge" (click)="openRecharge()">
          <span>+</span> Recharge
        </button>
      </div>
      <div class="sign-doc-card">
        <div class="sign-doc-card__icon-wrap">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#1b295c" stroke-width="1.8">
            <rect x="4" y="2" width="16" height="20" rx="2"></rect>
            <path d="M9 12h6M9 16h4"></path>
            <path d="M14 2v4h4"></path>
          </svg>
        </div>
        <div>
          <p class="sign-doc-card__title">Sign a document</p>
          <p class="sign-doc-card__desc">Upload a PDF, place your signature, done.</p>
          <a class="sign-doc-card__start" (click)="openEsignOverlay()" style="cursor:pointer">Start →</a>
        </div>
      </div>
    </div>
  </div>
</div>
<app-add-credits-modal [isOpen]="showAddCreditsModal" (closeModal)="onModalClose()">
</app-add-credits-modal>